import { Input } from 'components/uikit/inputs/Input';
import { useAdvancedForm } from 'helpers/form/useAdvancedForm';
import formStyles from './Druckdaten.module.scss';
import { Button } from 'components/uikit/buttons/Button';
import { StringParam, useQueryParams } from 'react-router-url-params';
import DownLoadIcon from '../../../assets/icons/download-icon.svg';

import clsx from 'clsx';

import { Breadcrumbs } from 'components/uikit/Breadcrumbs';
import { DXG, useDataGrid } from 'components/devexpress/Grid/dx-grid.ts';
import React, { useRef } from 'react';
import { AppLink } from '../../../components/uikit/buttons/AppLink.tsx';
import gridStyles from '../../../components/devexpress/Grid/grid.module.scss';
import { IconButton } from '../../../components/uikit/IconButton.tsx';
import { useScopedTranslation } from '../../../application/localization/useScopedTranslation.ts';
import { Tip } from '../../../components/uikit/Tip.tsx';
import { DataGridRef } from 'devextreme-react/data-grid';

type FormParams = {
  partNumber: string;
};

export const DruckdatenPage = () => {
  const [params, setParams] = useQueryParams({
    partNumber: StringParam,
  });
  useDataGrid();
  const i18n = useScopedTranslation('Page.DruckdatenPage');

  const form = useAdvancedForm<FormParams>(
    async (data) => {
      setParams(data);
    },
    {
      defaultValues: {
        partNumber: params.partNumber ?? '',
      },
    },
  );

  const documents: Record<string, string>[] = [
    { name: '26626A_Druck.pdf', date: '24 Sept 2024, 12:13', uploadUrl: '' },
    { name: '04890D_Druck.pdf', date: '24 Sept 2024, 12:11', uploadUrl: '' },
    { name: '93679C_Druck.pdf', date: '24 Sept 2024, 11:58', uploadUrl: '' },
    { name: '93679C_Druck.pdf', date: '24 Sept 2024, 11:58', uploadUrl: '' },
    { name: '93679C_Druck.pdf', date: '24 Sept 2024, 11:58', uploadUrl: '' },
    { name: '93679C_Druck.pdf', date: '24 Sept 2024, 11:58', uploadUrl: '' },
    { name: '93679C_Druck.pdf', date: '24 Sept 2024, 11:58', uploadUrl: '' },
    { name: '93679C_Druck.pdf', date: '24 Sept 2024, 11:58', uploadUrl: '' },
    { name: '93679C_Druck.pdf', date: '24 Sept 2024, 11:58', uploadUrl: '' },
  ];

  const dataGridRef = useRef<DataGridRef<any, number>>(null);

  return (
    <div>
      <Breadcrumbs></Breadcrumbs>
      <div>
        <label className={formStyles.h3}>
          {i18n.t('enter_article_number')}
        </label>
        <form onSubmit={form.handleSubmitDefault}>
          <div
            className={clsx(
              formStyles.rowContainer_gap12,
              formStyles.margin_top8,
            )}
          >
            <div className={formStyles.input_container}>
              <Input
                className={formStyles.inputWidth_400}
                {...form.register('partNumber')}
                placeholder={'Part number'}
                errorText={form.formState.errors.partNumber?.message}
              />
            </div>
            <Button
              className={formStyles.executeButton}
              type="submit"
              title={i18n.t('execute_btn')}
            />
            <label
              className={clsx(formStyles.greyText, formStyles.margin_left4)}
            >
              {i18n.t('print_data_released')}
            </label>
          </div>
        </form>
      </div>
      <div className={formStyles.rowContainer_gap4}>
        <label className={clsx(formStyles.margin_top12, formStyles.h3)}>
          {i18n.t('requested_documents')}
        </label>
        <div className={formStyles.margin_top12}>
          <Tip tooltipText={i18n.t('tooltip_text')}></Tip>
        </div>
      </div>
      {documents.length === 0 ? (
        <label className={clsx(formStyles.greyText, formStyles.margin_top8)}>
          No documents requested yet
        </label>
      ) : (
        <div>
          <DXG.DataGrid
            ref={dataGridRef}
            dataSource={documents}
            sorting={{ mode: 'none' }}
            className={clsx(
              gridStyles.editorOutline,
              formStyles.table,
              formStyles.margin_top8,
            )}
          >
            <DXG.Column
              dataField="name"
              caption={i18n.t('table_header_doc_name')}
              cssClass={formStyles.textCellPadding}
              minWidth={150}
              cellRender={(cell) => {
                return (
                  <AppLink className={formStyles.link} to={cell.data.uploadUrl}>
                    {cell.data.name}
                  </AppLink>
                );
              }}
            />
            <DXG.Column
              dataField="date"
              caption={i18n.t('table_header_receipt')}
              cssClass={clsx(formStyles.textCellPadding, formStyles.greyText)}
            />

            <DXG.Column
              cssClass={formStyles.textCellPadding}
              width={80}
              cellRender={() => {
                return (
                  <IconButton
                    iconClassName={formStyles.icon}
                    icon={DownLoadIcon}
                  />
                );
              }}
            />
            <DXG.Editing
              mode="cell"
              allowAdding={false}
              allowDeleting={false}
            />
          </DXG.DataGrid>
        </div>
      )}
    </div>
  );
};
